module.exports = "<p>\n  beasley works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/beasley.component.html
// module id = ../../../../../src/app/components/beasley/beasley.component.html
// module chunks = main